/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum SessionState {
    /**
     * Session is only a draft
     */ 
    Draft = -1,
    /**
     * Session was created
     */ 
    Scheduled = 0,
    /**
     * Session is recording
     */ 
    Running = 1,
    /**
     * Session is finished. No more recording can happen.
     */ 
    Stopped = 2,
    /**
     * Session is canceled. No more recording can happen.
     */ 
    Canceled = 3,
    /**
     * Session is currently stopped, happens when circuit round is finished.
     */ 
    Paused = 4,
    /**
     * Session is started but is currently not recording
     */ 
    Started = 5,
    /**
     * Session was aborted
     */ 
    Aborted = 6,
    /**
     * Session is Finished when all Scenario Recordings are finished(stopped)
     */ 
    Finished = 7,
    /**
     * Exam Session initiated Exam Confirmation Phase
     */ 
    ExamConfirmationRunning = 100,
    /**
     * Exam Session confirmation is done, the exam can be started
     */ 
    ExamConfirmationClosed = 101,
    /**
     * Exam Session MC started Exam Exam is now running
     */ 
    ExamRunning = 102,
    /**
     * Exam Session is in closing phase
     */ 
    ExamClosing = 103,
}
